import { get, post, patch } from 'api/request'

export const API_CONTACT = "/contact/service/contact"
export const API_ACTIVITY = "/contact/service/activity"

export const getActivityFilters = (listKey = 'all') => {
  let params = { offset: 0, size: 0 }
  return get(`${API_ACTIVITY}?group=${listKey}`, { urlParams: params })
}
export const getActivityFields = (key) => get(`${API_ACTIVITY}/activity_fields`)
export const getActivityList = (listKey, offset = 0, size = 20, filters = {}, order) => {
  let params = { offset, size }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  if (order)
    params["order"] = order
  return get(`${API_ACTIVITY}?group=${listKey}`, { urlParams: params })
}
export const getActivityDetail = (key) => get(`${API_ACTIVITY}/${key}`)
export const updateActivity = (key, data) => patch(`${API_ACTIVITY}/${key}`, data)
export const createActivity = (data) => post(`${API_CONTACT}/record_activity`, data)
export const addNewOptionActivity = (fieldName, option) => post(`${API_ACTIVITY}/activity_field_options/?field=${fieldName}`, option)

export const getLocationDetail = (lat, long) => get(`${API_ACTIVITY}/resolve_location?lat=${lat}&long=${long}`)

export const getActivityPrintUrl = (key) => get(`${API_ACTIVITY}/${key}/download_pdf`)